import axios from 'axios';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../Components/Loader/Loader';
import EmployeeReport from '../../Components/Reports/EmployeeReport';

const EmployeeReportPage = () => {
    const [travelInfo, setTravelInfo] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [ministryType, setMinistryType] = useState();

    useEffect(()=>{
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/employee`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            }
        }).then(response => {
                setTravelInfo(response.data?.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error(error);
                setIsLoading(false);
        });
    }, [])

    return (
        <>
            {
                isLoading ? (<Loader />) : (<EmployeeReport isLoading={isLoading} travelInfo={travelInfo} />)
            }
        </>
        
    );
};

export default EmployeeReportPage;